<template>
  <el-row :gutter="20" class="sec_box d2-mt-10 box-shadow" v-loading="loading">
    <p class="welfare_header">{{Year}}年</p>
    <template v-if="ListData.length != 0">
      <p class="welfare_total">共领取福利：<span>{{total}}次</span></p>
      <el-col :span="24" v-for="(item, index) in ListData" :key="index" class="list_item_box" :title="item.Title">
        <div class="img-row">
           <img src="@/assets/img/gift.png" />
        </div>
        <!-- <i class="el-icon-document" color='#5cb6ff' style="font-size:30px;color:#5cb6ff"></i> -->
        <div class="list_item_info">
          <p class="list_item_title">{{ item.TypeName || "-" }}<span
              class="list_item_time">({{ item.GrantStatus || "-" }})</span></p>
          <div class="list_item_content">{{ item.Name }}</div>
        </div>
        <div class="align-center">
          <span class="list_item_time">{{ item.CreateTime || "-" }}</span>
        </div>
      </el-col>
      <el-col :span="24" class="align-center mt-20">
        <span class="no_more">没有更多了~</span>
      </el-col>
    </template>
    <template v-else>
      <el-empty class="auto"></el-empty>
    </template>
  </el-row>
</template>

<script>
  import dayjs from "dayjs";
  import * as indexService from "@/api/sys/index";
  export default {
    name: "listWelfare",
    data() {
      return {
        Year: dayjs().format("YYYY"),
      };
    },
    props: {
      code: {
        type: String,
        required: false,
        default: "",
      },
      ListData: {
        type: Array,
        required: false,
        default: () => [],
      },
      loading: {
        type: Boolean,
        required: false,
        default: false,
      },
      total: {
        type: Number,
        required: false,
        default: 0,
      },
    },
    created() {},
    mounted() {},
    methods: {

    },
  };
</script>

<style lang="scss" scoped>
  @import "~@/assets/style/style.css";
  @import "~@/assets/style/richText.scss";

  .box-shadow {
    margin: auto auto;
    padding: 10px;
    box-shadow: 0px 0px 15px #bfd3e8;
    border-radius: 10px;
  }
  .welfare_header{font-size: 20px;margin: 5px 10px;}
  .welfare_total{font-size: 14px;color:#999;margin: 5px 10px;
  span{
    color: #99caf3;
  }}
</style>